import React from "react";
import { useLocation } from "react-router-dom";

const RegistrationSuccess = () => {
  const location = useLocation();
  const { message, paymentVerified } = location.state || {};

  return (
    <div className="container text-center mt-5">
      <h2>{message || "Registration Successful!"}</h2>
      {paymentVerified && <p>Your payment was successfully verified.</p>}
    </div>
  );
};

export default RegistrationSuccess;
